<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert
          type="error"
          class="alert_all_page"
          v-if="alert_error === true"
          >{{ alert_message_error }}</v-alert
        >
        <v-alert
          type="success"
          class="alert_all_page"
          v-if="alert_success === true"
          >{{ alert_message_success }}</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col
          xs="12"
          sm="12"
          md="4"
          lg="2"
          xl="2"
          cols="12"
          class="title_page_center_right"
        >
          <div style="float: right">
            <v-badge
              class="text-center"
              color="error"
              :content="count_cart"
              overlap
            >
              <v-btn
                elevation="3"
                height="45"
                @click="link('/arin/pos/cartlist')"
                class="white--text"
                style="
                  border-radius: 10px;
                  background-color: #d6bfaf !important;
                "
              >
                <v-icon size="32">mdi-cart</v-icon>
              </v-btn>
            </v-badge>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" style="border-radius: 15px">
            <v-card-title>
              <v-row>
                <v-col xs="12" sm="6" md="3" lg="2" xl="2" cols="12">
                  <v-select
                    color="#D6BFAF"
                    class="input-radius"
                    :items="product_type_list"
                    item-text="name"
                    item-value="id"
                    v-model="product_type"
                    @change="getProductList()"
                    label="ทั้งหมด"
                    hide-details="auto"
                    single-line
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col xs="12" sm="6" md="3" lg="2" xl="2" cols="12">
                  <v-select
                    color="#D6BFAF"
                    class="input-radius"
                    :items="promotion_list"
                    item-text="name"
                    item-value="value"
                    v-model="promotion_type"
                    @change="getProductList()"
                    label="โปรโมชั่น"
                    hide-details="auto"
                    single-line
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col
                  class="text-center"
                  xs="12"
                  sm="12"
                  md="3"
                  lg="2"
                  xl="2"
                  cols="12"
                >
                  <v-btn
                    elevation="4"
                    class="btn_exp_list"
                    color="#FEA06C"
                    @click="link('/arin/pos/productempty')"
                    style="border-radius: 10px; background-color: #ffffff"
                    title="ดูรายการสินค้าใกล้หมดคลัง"
                    outlined
                  >
                    <div style="color: #fea06c">ดูรายการสินค้าใกล้หมดคลัง</div>
                  </v-btn>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-text-field
                    color="#D6BFAF"
                    class="input-radius inp-text-field"
                    append-icon="mdi-magnify"
                    style="float: right"
                    hide-details="auto"
                    required
                    v-model="search"
                    @change="searchProductList()"
                    placeholder="ค้นหา..."
                    single-line
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th style="font-size: 16px; text-align: center">
                          รูปภาพ
                        </th>
                        <th style="font-size: 16px">สินค้า</th>
                        <th style="font-size: 16px; text-align: center">
                          คลังคงเหลือ
                        </th>
                        <th style="font-size: 16px; text-align: center" v-if="customer_type != 3">
                          ราคาต่อหน่วย
                        </th>
                        <th style="font-size: 16px; text-align: center">
                          จำนวน
                        </th>
                        <th style="font-size: 16px; text-align: center" v-if="customer_type != 3">
                          ราคารวม
                        </th>
                        <th style="font-size: 16px; text-align: center">
                          หยิบใส่ตระกร้า
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detail, index) in data_list" :key="index">
                        <td class="pa-3 hidden_line">
                          <div class="d-block text-center">
                            <v-img
                              height="80"
                              max-width="80"
                              :lazy-src="detail.picture"
                              :src="detail.picture"
                              class="preview"
                              v-if="detail.picture"
                            ></v-img>
                            <v-img
                              height="80"
                              max-width="80"
                              :lazy-src="img_holder"
                              :src="img_holder"
                              class="preview"
                              v-if="!detail.picture"
                            ></v-img>
                            <span
                              v-if="detail.product_exp != null"
                              style="color: red"
                              >Exp.
                              {{
                                `${detail.product_exp.split("-")[2]}/${
                                  detail.product_exp.split("-")[1]
                                }/${detail.product_exp.split("-")[0]}`
                              }}</span
                            >
                          </div>
                        </td>
                        <td class="hidden_line" style="width: 450px !important">
                          <div>{{ detail.name }}</div>
                          <div class="grey--text">
                            <small v-if="promotion_type != 'set'">{{
                              detail.name_sci
                            }}</small>
                            <small class="mb-5"></small>
                          </div>
                          <div
                            v-if="promotion_type != 'mains'"
                            class="d-flex justify-content-start"
                          >
                            <div
                              :class="
                                promotion_type != 'set' ? 'd-block' : 'd-none'
                              "
                              v-for="(item, index_unit) in detail.unitList"
                              :key="index_unit"
                            >
                              <div
                                class="ma-2 tag_border_unit"
                                :class="{
                                  tag_border_unit_active: item.status !== false,
                                }"
                                @click="
                                  selectUnit(detail, detail.unitList, item)
                                "
                              >
                                {{ item.name }}
                              </div>
                            </div>
                            <div v-if="detail.unitList.length == 0">
                              <div
                                class="ma-2 tag_border_unit tag_border_unit_active"
                              >
                                {{ detail.unit_name }}
                              </div>
                            </div>
                          </div>
                          <div v-else class="d-block">
                            <div
                              v-for="(item, index_unit) in detail.unitList"
                              :key="index_unit"
                            >
                              <span style="font-size: 15px"
                                >-{{ item.product_name }}
                                {{ item.quantity_per_sell }}
                                {{ item?.unit_name }}</span
                              >
                            </div>
                          </div>
                          <div>
                            <span
                              v-if="promotion_type == 'expired'"
                              style="color: red"
                              >คลัง : {{ detail.limit }}</span
                            >
                            <span v-if="promotion_type == 'set'"
                              >ชุดคละ {{ detail.qty_per_set }} ชิ้น</span
                            >
                          </div>
                        </td>
                        <td class="hidden_line">
                          <div class="text-center">
                            {{
                              detail.total_quantity ? detail.total_quantity : 0
                            }}
                          </div>
                        </td>
                        <td class="hidden_line" v-if="customer_type != 3">
                          <div class="text-center" v-if="type != 1">
                            <div>฿ {{ detail.retail_price }}</div>
                            <div
                              v-if="promotion_type == 'expired'"
                              class="text-decoration-line-through"
                              style="color: red"
                            >
                              ฿ {{ detail.old_cost }}
                            </div>
                          </div>
                          <div class="text-center" v-else>
                            ฿ {{ detail.price ? detail.price : "-" }}
                          </div>
                        </td>
                        <td class="hidden_line" style="padding: 0">
                          <div style="display: flex; justify-content: center">
                            <v-btn
                              class="mt-1"
                              color="#D6BFAF"
                              height="17px"
                              width="17px"
                              style="border-radius: 5px; border-color: #d6bfaf"
                              @click="
                                promotion_type != ''
                                  ? detail.quantity > 1
                                    ? (detail.quantity -= 1)
                                    : ''
                                  : subtractQuantity(detail)
                              "
                              fab
                              x-small
                              dark
                              outlined
                            >
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <!-- <p class="ml-2 mr-2">{{ detail.quantity }}</p> -->
                            <v-text-field
                              class="input-radius input-center mr-2 ml-2"
                              type="text"
                              v-model="detail.quantity"
                              color="#D6BFAF"
                              value="1"
                              style="width: 10px; text-align: center"
                              @keypress="isNumber($event, detail.quantity)"
                              @change="calculate(index)"
                              @paste="isPaste($event)"
                              hide-details="auto"
                              single-line
                              solo
                              outlined
                              dense
                              required
                            >
                            </v-text-field>
                            <v-btn
                              v-if="
                                promotion_type == '' || promotion_type == null
                              "
                              class="mt-1"
                              color="#D6BFAF"
                              height="17px"
                              width="17px"
                              style="border-radius: 5px; border-color: #d6bfaf"
                              @click="addQuantity(detail)"
                              fab
                              x-small
                              dark
                              outlined
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              class="mt-1"
                              color="#D6BFAF"
                              height="17px"
                              width="17px"
                              style="border-radius: 5px; border-color: #d6bfaf"
                              @click="
                                detail.limit > detail.quantity
                                  ? (detail.quantity += 1)
                                  : ''
                              "
                              fab
                              x-small
                              dark
                              outlined
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </td>
                        <td class="hidden_line" v-if="customer_type != 3">
                          <div class="text-center" v-if="type != 1">
                            ฿
                            {{
                              format_price(
                                detail.retail_price * detail.quantity
                              )
                            }}
                          </div>
                          <div class="text-center" v-else>
                            ฿ {{ format_price(detail.price * detail.quantity) }}
                          </div>
                        </td>
                        <td class="hidden_line text-center">
                          <v-btn
                            v-if="promotion_type == 'set'"
                            elevation="3"
                            class="ma-2"
                            outlined
                            small
                            height="45"
                            :color="detail.price ? '#D6BFAF' : 'grey'"
                            :disabled="!detail.price"
                            style="
                              border-radius: 10px;
                              background-color: #ffffff;
                            "
                            title="เพิ่มลงตะกร้า"
                            @click="
                              ((set_list = detail.unitList.map((o) => {
                                return { ...o, selected_qty: 1 };
                              })),
                              (set_data = detail),
                              (qty_per_set = detail.qty_per_set),
                              (show_modal = !show_modal))
                            "
                          >
                            <v-icon>mdi-cart-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            elevation="3"
                            class="ma-2"
                            outlined
                            small
                            height="45"
                            :color="detail.price ? '#D6BFAF' : 'grey'"
                            :disabled="!detail.price"
                            style="
                              border-radius: 10px;
                              background-color: #ffffff;
                            "
                            title="เพิ่มลงตะกร้า"
                            @click="addCart(detail)"
                          >
                            <v-icon>mdi-cart-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                      <div class="mr-2">Rows per page:</div>
                      <div style="width: 20%">
                        <v-select
                          class="pa-0 ma-0"
                          color="#D6BFAF"
                          :items="size_list"
                          item-text="name"
                          item-value="id"
                          v-model="size"
                          hide-details="auto"
                        ></v-select>
                      </div>
                    </div>
                    <div style="width: 30%">
                      <v-pagination
                        class="pagination_arin"
                        v-model="page"
                        color="#D6BFAF"
                        :length="count_page"
                      ></v-pagination>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="show_modal" max-width="800">
      <v-card>
        <v-form ref="add_form" @submit.prevent="">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3" class="d-flex justify-center">
                <v-img
                  v-if="set_data.picture"
                  height="80"
                  max-width="80"
                  width="80"
                  :lazy-src="img_holder"
                  :src="set_data.picture"
                  class="m-auto"
                ></v-img>
                <v-img
                  v-else
                  height="80"
                  max-width="80"
                  width="80"
                  :lazy-src="img_holder"
                  :src="img_holder"
                  class="m-auto"
                ></v-img>
              </v-col>
              <v-col cols="9">
                <v-row>
                  <v-col cols="12">
                    <span>ชุดคละ {{ qty_per_set }} ชิ้น</span>
                  </v-col>
                  <v-col cols="12">
                    <b>เลือกสินค้า </b>
                    <span style="color: red">
                      กรุณาเลือกสินค้า จำนวน
                      {{ qty_per_set }} ชิ้น
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="d-flex flex-item-center justify-lg-space-between"
                    v-for="item in set_list"
                    :key="item.id"
                  >
                    <div class="my-auto">
                      <span
                        >{{ item.product_name }} {{ item.quantity }}
                        {{ item.unit_name }}</span
                      >
                    </div>
                    <div class="d-flex">
                      <v-btn
                        class="mt-1"
                        color="#D6BFAF"
                        height="30px"
                        width="30px"
                        style="border-radius: 5px; border-color: #d6bfaf"
                        @click="
                          item.selected_qty > 1 ? (item.selected_qty -= 1) : ''
                        "
                        fab
                        x-small
                        dark
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      <v-text-field
                        color="#D6BFAF"
                        class="input-radius inp-text-field"
                        style="width: 150px"
                        hide-details="auto"
                        required
                        v-model="item.selected_qty"
                        single-line
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                      <v-btn
                        class="mt-1"
                        color="#D6BFAF"
                        height="30px"
                        width="30px"
                        style="border-radius: 5px; border-color: #d6bfaf"
                        @click="checkMax(item)"
                        fab
                        x-small
                        dark
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-spacer></v-spacer>
          <div class="text-center pa-4">
            <v-btn @click="addCart(set_list)" color="success">บันทึก</v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import {
  isTelephone,
  onPaste,
  onlyForCurrency,
  formatPrice,
  taxNumber,
} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_product_list",
  data() {
    return {
      customer_type: null,
      loading_page: true,
      search: "",
      img_holder: img_holder,
      alert_success: false,
      show_modal: false,
      set_list: [],
      set_data: {},
      qty_per_set: 0,
      alert_message_success: null,
      product_type_list: [{ id: "", name: "ทั้งหมด" }],
      product_type: 0,
      promotion_list: [
        { value: "", name: "โปรโมชั่น" },
        { value: "expired", name: "โปรโมชั่นลดล้างสต๊อก" },
        { value: "mains", name: "โปรโมชั่นชุดเซ็ต" },
        { value: "set", name: "โปรโมชั่นชุดคละ" },
      ],
      promotion_type: "",
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "ออกใบสั่งซื้อ",
          disabled: false,
        },
        {
          text: "รายการสินค้า",
          disabled: false,
          href: "#",
        },
      ],
      size_list: [
        { id: 5, name: "5" },
        { id: 10, name: "10" },
        { id: 15, name: "15" },
        { id: "all", name: "All" },
      ],
      page: 1,
      size: 10,
      count_page: 1,
      type: null,
      count_cart: "0",
      data_list: [],
      widthClass: "w-10px",
    };
  },
  methods: {
    getShow_api() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      HTTP_ARIN.get("/profile/detail", config).then((res) => {
        if (res.data.successful === true) {
          // ถ้า login มาจาก customer (เจ้าของร้าน)
          if (res.data.ProfileDetail) {
            this.customer_type = res.data.ProfileDetail.customer_type;
          }

          // ถ้า login มาจาก employee (พนักงาน)
          else if (res.data.ProfileDetail_emp) {
            this.customer_type = res.data.ProfileDetail.customer_type;
          }
        }
      });
    },
    checkMax(item) {
      let sum_selected_qty = 0;
      this.set_list.map((o) => {
        sum_selected_qty += o.selected_qty;
      });
      if (sum_selected_qty < this.qty_per_set) {
        item.selected_qty += 1;
      }
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    link(link_url) {
      this.$router.push(link_url);
    },
    selectUnit(item, unit_item_list, unit_item) {
      let num_unit_item_list = unit_item_list.length;
      for (let index = 0; index < num_unit_item_list; index++) {
        unit_item_list[index].status = false;
      }
      unit_item.status = true;
      item.unit_id = unit_item.unit_id;
      item.price = unit_item.price;
      item.weight = unit_item.weight;
    },
    addQuantity(item) {
      if (item.quantity >= 0) {
        //  if(item.limit >= item.quantity){
        item.quantity++;
        const data = {
          product_id: item.id,
          unit_id: item.unit_id,
          quantity: item.quantity,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        HTTP_ARIN.post("/pos/product/check/special/price", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              item.price = res.data.cost;
            }
          }
        );
        //  }
      }
    },
    subtractQuantity(item) {
      if (item.quantity > 1) {
        // if(item.limit >= item.quantity){
        item.quantity--;
        const data = {
          product_id: item.id,
          unit_id: item.unit_id,
          quantity: item.quantity,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        HTTP_ARIN.post("/pos/product/check/special/price", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              item.price = res.data.cost;
            }
          }
        );
        // }
      }
    },
    async getProductTypeList() {
      this.loading_page = true;
      this.product_type_list = [{ id: "", name: "ทั้งหมด" }];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/pos/producttype", config).then((res) => {
        if (res.data.successful === true) {
          const num_product_type = res.data.product_type.length;
          for (let index = 0; index < num_product_type; index++) {
            this.product_type_list.push({
              id: res.data.product_type[index].id,
              name: res.data.product_type[index].name,
            });
          }
          this.loading_page = false;
        }
      });
    },
    async getProductList() {
      this.loading_page = true;
      this.data_list = [];
      this.type = null;
      const data = {
        search: this.search,
        product_type: this.product_type,
        promotion_type: this.promotion_type,
        page: this.page,
        size: this.size,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.post("/pos/products", data, config).then((res) => {
        if (res.data.successful === true) {
          this.count_page = res.data.count_page;
          const num_product = res.data.product.length;
          for (let index = 0; index < num_product; index++) {
            let unit_list = [];
            let num_unit = res.data.product[index].unitList.length;
            let unit_id = null;
            let price = null;
            let weight = null;
            for (let index_unit = 0; index_unit < num_unit; index_unit++) {
              unit_list.push({
                unit_id: res.data.product[index].unitList[index_unit].unit_id,
                name: res.data.product[index].unitList[index_unit].name,
                price: res.data.product[index].unitList[index_unit].price,
                weight: res.data.product[index].unitList[index_unit].weight,
                product_name:
                  res.data.product[index].unitList[index_unit].product_name,
                product_id: res.data.product[index].unitList[index_unit]
                  .product_id
                  ? res.data.product[index].unitList[index_unit].product_id
                  : null,
                quantity_per_sell:
                  res.data.product[index].unitList[index_unit]
                    .quantity_per_sell,
                quantity: res.data.product[index].unitList[index_unit].quantity,
                unit_name:
                  res.data.product[index].unitList[index_unit].unit_name,
                status: index_unit != 0 ? false : true,
              });
              if (index_unit == 0) {
                unit_id = res.data.product[index].unitList[index_unit].unit_id;
                price = res.data.product[index].unitList[index_unit].price;
                weight = res.data.product[index].unitList[index_unit].weight;
              }
            }
            if (num_unit == 0) {
              unit_id = res.data.product[index].unit_id;
              price = res.data.product[index].price;
              weight = res.data.product[index].weight;
            }
            this.data_list.push({
              id: res.data.product[index].id,
              picture: res.data.product[index].picture,
              name: res.data.product[index].name,
              name_sci: res.data.product[index].name_sci,
              total_quantity: res.data.product[index].total_quantity,
              unitList: unit_list,
              unit_id: unit_id,
              price: price,
              retail_price: res.data.product[index].retail_price,
              in_stock: res.data.product[index].in_stock,
              qty_per_set: res.data.product[index].qty_per_set,
              old_cost: res.data.product[index].old_cost
                ? res.data.product[index].old_cost
                : 0,
              weight: weight,
              quantity: 1,
              product_exp: res.data.product[index].product_exp
                ? res.data.product[index].product_exp
                : null,
              unit_name: res.data.product[index].unit_name
                ? res.data.product[index].unit_name
                : null,
              limit: res.data.product[index].limit
                ? res.data.product[index].limit
                : 0,
            });
          }
          this.type = res.data.type;
          this.loading_page = false;
        }
      });
    },
    async countCart() {
      this.count_cart = "0";
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/pos/count/cart", config).then((res) => {
        if (res.data.successful === true) {
          this.count_cart = res.data.count.toString();
        }
      });
    },
    async searchProductList() {
      this.data_list = [];
      this.type = null;
      const data = {
        search: this.search,
        product_type: this.product_type,
        promotion_type: this.promotion_type,
        page: this.page,
        size: this.size,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.post("/pos/products", data, config).then((res) => {
        // console.log(res.data);
        if (res.data.successful === true) {
          this.count_page = res.data.count_page;
          const num_product = res.data.product.length;
          for (let index = 0; index < num_product; index++) {
            let unit_list = [];
            let num_unit = res.data.product[index].unitList.length;
            let unit_id = null;
            let price = null;
            let weight = null;
            for (let index_unit = 0; index_unit < num_unit; index_unit++) {
              unit_list.push({
                unit_id: res.data.product[index].unitList[index_unit].unit_id,
                name: res.data.product[index].unitList[index_unit].name,
                price: res.data.product[index].unitList[index_unit].price,
                weight: res.data.product[index].unitList[index_unit].weight,
                old_cost: res.data.product[index].old_cost
                  ? res.data.product[index].old_cost
                  : 0,
                product_name:
                  res.data.product[index].unitList[index_unit].product_name,
                product_id: res.data.product[index].unitList[index_unit]
                  .product_id
                  ? res.data.product[index].unitList[index_unit].product_id
                  : null,
                quantity_per_sell:
                  res.data.product[index].unitList[index_unit]
                    .quantity_per_sell,
                quantity: res.data.product[index].unitList[index_unit].quantity,
                unit_name:
                  res.data.product[index].unitList[index_unit].unit_name,
                status: index_unit != 0 ? false : true,
              });
              if (index_unit == 0) {
                unit_id = res.data.product[index].unitList[index_unit].unit_id;
                price = res.data.product[index].unitList[index_unit].price;
                weight = res.data.product[index].unitList[index_unit].weight;
              }
            }
            this.data_list.push({
              id: res.data.product[index].id,
              picture: res.data.product[index].picture,
              name: res.data.product[index].name,
              name_sci: res.data.product[index].name_sci,
              total_quantity: res.data.product[index].total_quantity,
              unitList: unit_list,
              unit_id: unit_id,
              price: price,
              retail_price: res.data.product[index].retail_price,
              qty_per_set: res.data.product[index].qty_per_set,
              old_cost: res.data.product[index].old_cost
                ? res.data.product[index].old_cost
                : 0,
              product_exp: res.data.product[index].product_exp
                ? res.data.product[index].product_exp
                : null,
              unit_name: res.data.product[index].unit_name
                ? res.data.product[index].unit_name
                : null,
              weight: weight,
              quantity: 1,
              limit: res.data.product[index].limit
                ? res.data.product[index].limit
                : 0,
            });
          }
          this.type = res.data.type;
        }
      });
    },

    async addCart(detail) {
      if (detail.quantity > 0 || this.promotion_type == "set") {
        let data = {};
        if (this.promotion_type != "set") {
          data = {
            type: this.type,
            product_id: detail.id,
            unit_id: detail.unit_id,
            quantity: detail.quantity,
            cost: detail.price,
            total: detail.price * detail.quantity,
            weight: detail.weight,
          };
        } else {
          let weight = 0;
          this.set_list.map((o) => {
            weight += parseFloat(o.weight) * o.selected_qty;
          });
          data = {
            type: this.type,
            product_id: this.set_data.id,
            unit_id: this.set_data.unit_id,
            quantity: this.set_data.quantity,
            cost: this.set_data.retail_price,
            total: this.set_data.retail_price * this.set_data.quantity,
            weight: weight,
            set_list: this.set_list.map((o) => {
              return {
                product_id: o.product_id,
                unit_id: o.unit_id,
                quantity: o.selected_qty,
              };
            }),
          };
        }
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        HTTP_ARIN.post("/pos/add/to/cart", data, config).then((res) => {
          if (res.data.successful === true) {
            this.alert_success = true;
            this.alert_message_success = "เพิ่มสินค้าลงตะกร้าเรียบร้อย";
            if (this.promotion_type != "set") {
              detail.quantity = 1;
            } else {
              this.show_modal = false;
            }
            this.countCart();
          }
        });
      }
    },
    toggleColAndDiv() {
      // Toggle the class name for v-col
      this.colClass = this.colClass === "col-12" ? "col-9" : "col-12";
      this.widthClass = this.colClass === "col-12" ? "w-10px" : "w-45px";
      // Toggle the visibility of the hidden div
      this.showHiddenDiv = !this.showHiddenDiv;
    },
    isNumber: function (evt, number) {
      console.log(evt);
      return isTelephone(evt, number);
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number);
    },
    isPaste: function (evt) {
      return onPaste(evt);
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
  },
  created() {
    this.getProductTypeList();
    this.getProductList();
    this.getShow_api();
  },
  mounted() {
    this.countCart();
  },
  watch: {
    size() {
      this.getProductList();
    },
    page() {
      this.getProductList();
    },
    search() {
      this.searchProductList();
    },
  },
};
</script>

<style scoped>
.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.34%;
}

.input-radius {
  border-radius: 10px;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.width >>> input {
  max-width: 100%;
  text-align: center;
}

@media only screen and (min-width: 0px) AND (max-width: 361px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #fff;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
      #88b358 !important;
    border-radius: 10px;
    width: 100% !important;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #fff;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
      #88b358 !important;
    border-radius: 10px;
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .inp-text-field {
    width: 50%;
  }
}

/* @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .inp-text-field {
    width: 23%;
  }
} */
</style>
